import { IFormControl } from '../interfaces';
import {
    ChangeEventHandler,
    ClipboardEventHandler,
    FocusEventHandler,
    KeyboardEventHandler,
    MouseEventHandler,
    ReactNode
} from 'react';

interface ISelectOption {
    key: any,
    value: any,
    text: string,
}

interface ISelectSimpleFieldProps {
    id: string,
    label: string,
    control: IFormControl,

    options: ISelectOption[],
    initialSelectionText?: string,

    // event handlers
    onBlur?: FocusEventHandler,
    onChange?: ChangeEventHandler,
    onClick?: MouseEventHandler,
    onKeyUp?: KeyboardEventHandler,
    onPaste?: ClipboardEventHandler,

    // html content
    comment?: ReactNode,

    // styles
    rootClasses?: string,
    selectClasses?: string,
}

const SelectSimpleField = (props: ISelectSimpleFieldProps) => {

    const {
        id, label, control, options,
        onChange, onBlur, onClick,
        comment, rootClasses,  selectClasses,
        initialSelectionText,
    } = props;
    
    return (
        <div className={ rootClasses ? rootClasses : 'mb-6'}>
            <div className={`w-form-field ${ !control.isValid ? 'w-form-error' : '' } `}>

                <select
                    id={ id }
                    className={ `w-form-tb ${ selectClasses || '' }  ${ control.value ? 'not-empty': '' } ` }
                    value={ control.value }
                    onBlur={ onBlur }
                    onChange={ onChange }
                    onClick={  onClick }
                >
                    { initialSelectionText && <option value={ '' }>{ initialSelectionText }</option> }
                    {
                        options.map(option => {
                            return (
                                <option value={ option.value } key={ option.key }>{ option.text }</option>
                            )
                        })
                    }
                </select>

                <label htmlFor={ id } className="w-form-label">{ label }</label>
            </div>

            { control.isValid && comment }

            {
                !control.isValid &&
                <div className="text-red text-sm">{ control.error }</div>
            }
        </div>
    )
};

export default SelectSimpleField;